import { render, staticRenderFns } from "./ElPopover.vue?vue&type=template&id=7e96992e"
import script from "./ElPopover.vue?vue&type=script&lang=js"
export * from "./ElPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports